import { Box } from "@mui/material";
import theme from "../../Theme";

export function GradientBorderBox({
  zIndex = -1,
  inside = false,
  overHidden = false,
  borderSize = ".15rem",
  radius = "1.5rem",
  bgGrad = `linear-gradient(
    90deg,
    ${theme.palette.primary.main} -30%,
    ${theme.palette.background.default} 50%,
    ${theme.palette.background.white} 130%
  )`,
  bg = true,
}) {
  return (
    <Box
      sx={{
        position: "absolute",
        top: inside ? 0 : `-${borderSize}`,
        right: inside ? 0 : `-${borderSize}`,
        left: inside ? 0 : `-${borderSize}`,
        bottom: inside ? 0 : `-${borderSize}`,
        zIndex,
        overflow: overHidden ? "hidden" : "visible",
        // bgcolor:"red"
      }}
    >
      <Box
        sx={{
          position: "relative",
          borderRadius: radius,
          height: "100%",
          background: bg ? "transparent" : undefined,
          backdropFilter: bg ? "blur(8px)" : undefined,
          padding: "1rem",
          "&::before": {
            content: '""',
            position: "absolute",
            inset: 0,
            padding: borderSize,
            borderRadius: "inherit",
            background: bgGrad,
            pointerEvents: "none",

            // —— CROSS-BROWSER MASKING —— //

            // Chrome / Safari
            WebkitMask:
              "linear-gradient(#fff 0 0) content-box, linear-gradient(#fff 0 0)",
            WebkitMaskComposite: "xor",

            // Firefox (mask + exclude)
            mask: "linear-gradient(#fff 0 0) content-box, linear-gradient(#fff 0 0)",
            maskComposite: "exclude",
          },
        }}
      />
    </Box>
  );
}
